// removed by extract-text-webpack-plugin
module.exports = {"header":"_3ESJ","head-img-area":"_3O3l","headertxt1":"_3Oem","headertxt2":"_3rEM","headertxt3":"_29-E","merc-name":"_19sZ","mlogo":"_10tp","wlogo":"_3Siz","fee-for":"_2yKE","m-hidelogo":"_3jHf","fee-for-pos":"_Zv4c","w-hidelogo":"_2Gj5","down-arr":"_3jZ7","m-hide":"_396X"};


//////////////////
// WEBPACK FOOTER
// ./form/components/merchantinfo/style.css
// module id = yRZD
// module chunks = 4